import { useContext } from "react";
import { useTranslation } from "utilities/i18n";
import { ExpandableCard } from "collections/Cards";
import DevicesImport from "./DevicesImport";
import { protect } from "TsRoleGuards";
import { Layout } from "views/Main/Layouts";
import { State } from "store";
import { SelectedTenantContext } from "polyrouter/SelectedTenantProvider";
import { useSelector } from "react-redux";
import DeviceGroupsImport from "./DeviceGroupsImport";
import SitesImport from "./SitesImport";
import DeviceModelsImport from "./DeviceModelsImport";
import DevicesExport from "./DevicesExport";
import Migration from "./Migration";

const Section: React.FC<{
  title: string;
}> = ({ title, children }) => {
  const { Content } = Layout;
  return (
    <>
      <div className="mb-1">
        <Content.Title>{title}</Content.Title>
      </div>
      <div className="mb-3">{children}</div>
    </>
  );
};

const AdvancedTools: React.FC = () => {
  const { t } = useTranslation();
  const { tenant } = useContext(SelectedTenantContext);
  const tenantId = tenant?.id ?? "";
  const { inProgress, finished, type } = useSelector(
    (state: State) => state.import[tenantId] ?? {}
  );
  const importActive = inProgress || finished;

  const { Content } = Layout;

  return (
    <Layout>
      <Content scrolling>
        <Content.ScrollingList>
          <div className="advanced-tools-container">
            <Section title={t("IMPORT")}>
              <ExpandableCard
                collapsedContent={
                  <div className="category-title pl-5">{t("DEVICES")}</div>
                }
                dropdown
                expanded={importActive && type === "DEVICE"}
              >
                <DevicesImport />
              </ExpandableCard>
              <ExpandableCard
                collapsedContent={
                  <div className="category-title pl-5">
                    {t("DEVICE_GROUPS")}
                  </div>
                }
                dropdown
                expanded={importActive && type === "DEVICE_GROUP"}
              >
                <DeviceGroupsImport />
              </ExpandableCard>
              <ExpandableCard
                collapsedContent={
                  <div className="category-title pl-5">{t("SITE_other")}</div>
                }
                dropdown
                expanded={importActive && type === "SITE"}
              >
                <SitesImport />
              </ExpandableCard>
              <ExpandableCard
                collapsedContent={
                  <div className="category-title pl-5">
                    {t("DEVICE_MODEL_other")}
                  </div>
                }
                dropdown
                expanded={importActive && type === "DEVICE_MODEL"}
              >
                <DeviceModelsImport />
              </ExpandableCard>
            </Section>
            <Section title={t("EXPORT")}>
              <ExpandableCard
                collapsedContent={
                  <div className="category-title pl-5">{t("DEVICES")}</div>
                }
                dropdown
                expanded={false}
              >
                <DevicesExport />
              </ExpandableCard>
            </Section>
            <Section title={t("MIGRATION_TOOLS")}>
              <ExpandableCard
                collapsedContent={
                  <div className="category-title pl-5">
                    {t("MIGRATE_EXISTING_ACCOUNT")}
                  </div>
                }
                dropdown
                expanded={importActive && type === "MIGRATION"}
              >
                <Migration />
              </ExpandableCard>
            </Section>
          </div>
        </Content.ScrollingList>
      </Content>
    </Layout>
  );
};

export default protect("UPDATE_SITES")(AdvancedTools);
